import type React from 'react';

import type { TransitionDirection } from 'hooks/api/use-clients';

export interface TransitionCopy {
  headerText: string;
  body: React.ReactNode;
  toTransitionLabel: string;
  confirmLabel: string;
}

export const TRANSITION_COPY = {
  toSso: {
    headerText: 'Transition users to SSO',
    body: (
      <div>
        <p className="mb-3 mt-3">
          Recommended for clients who have recently enabled SSO. This action
          marks users as SSO authenticated in Okta.
        </p>
        <p className="mb-3">
          Demo, internal, and test users will not be affected.
        </p>
        <p className="font-bold"> Overview:</p>
        <ul className="list-disc pl-5">
          <li>Removes each user's current password</li>
          <li>
            Prevents each user from setting or signing in with a password in the
            future
          </li>
          <li>Emails users to notify them of the change</li>
        </ul>
      </div>
    ),
    toTransitionLabel: 'SSO',
    confirmLabel: 'Transition to SSO',
  },
  toOkta: {
    headerText: 'Transition users to Okta',
    body: (
      <div>
        <p className="mb-3 mt-3">
          Required for clients who have recently disabled SSO. Without SSO,
          users will need to setup an Okta password in order to sign in.
        </p>
        <p className="mb-3">
          Demo, internal, and test users will not be affected.
        </p>
        <p className="font-bold"> Overview:</p>
        <ul className="list-disc pl-5">
          <li>Users will be sent an email with a "Set Password" link</li>
          <li>
            Until users set their password, they will not be able to login
          </li>
        </ul>
      </div>
    ),
    toTransitionLabel: 'Okta',
    confirmLabel: 'Transition to Okta',
  },
} as const satisfies Record<TransitionDirection, TransitionCopy>;
